<template>

<v-container class="grey lighten-5">
  <br>
    <v-row no-gutters>
      <v-col
        v-for="n in 1"
        :key="n"
        cols="12"
        sm="12"
      >
        <v-card
          class="pa-2"
          min-height="200px"
          outlined
          tile
        >
          Please select content from the menu at left
          <v-progress-linear
      color="blue"
      indeterminate
      reverse
    ></v-progress-linear>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
    
</template>
<script>
export default {
    
}
</script>